/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import "./Attendence.css";
import Axios from "axios";
import Swal from "sweetalert2";

const Attendence = () => {

  const handleSubmit = async (e) => {
    e.preventDefault();

    const batchdata = {
      serial_id: e.target.studentid.value,
    };
    try {
      await Axios.post("https://lawacademyadmin.icicle.dev/api/attendance", batchdata).then(
        (response) => {
          if (response.status === 200) {
            Swal.fire({
              icon: "success",
              title: "Success!",
              text: "Your Attendance Successful",
              confirmButtonText: "Ok",
              confirmButtonColor: "#006837",
            });
            e.target.reset();
          }
          console.log(response);
        }
      );
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Something went wrong!",
        text: "Please Check Your Data",
        confirmButtonText: "Ok",
        confirmButtonColor: "red",
      });
    }
  };

  return (
    <div className="attendance-container">
      <form className="form" onSubmit={handleSubmit}>
        <h2 className="attendance_title">Attendance</h2>

        <div>
          <label style={{ display: "block", marginBottom: "5px" }}>Student ID</label>
          <input
            required
            className="hover-border"
            name="studentid"
            style={{
              width: "100%",
              marginBottom: "10px",
              padding: "10px",
            }}
            type="text"
            placeholder="Enter Your Student ID"
          />
        </div>

        {/* <div>
          <label className="attendance_label" htmlFor="batch">
            Batch Name:
          </label>
          <select
            required
            name="batch"
            className="hover-border"
            style={{
              width: "100%",
              marginBottom: "10px",
              padding: "10px",
            }}
          >
            <option value="" hidden>
              Select Batch
            </option>
            {batchNames.map((batch, idx) => (
              <option key={idx} value={batch.id}>
                {batch.batch_name}
              </option>
            ))}
          </select>
        </div> */}

        <button className="attendance_button" type="submit">
          Submit
        </button>
      </form>
    </div>
  );
};

export default Attendence;
